module.exports = __webpack_public_path__ + "img/kr-product-finance-card2-bg.ad9cfe4.png";